import { Table, Button } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import Notifier from "../../components/Notifier";

import Api from "../../utils/Api";
import remove_button from "../../resources/remove.png";

const MODES = {
    TAGS: "TAGS",
    CATEGORIES: "CATEGORIES",
    AUTOMATIONS: "AUTOMATIONS"
};

export default function Lookups({ mode, isMobile }) {
    const [newEntityDescription, setNewEntityDescription] = useState("");
    const [entity, setEntity] = useState([]);
    const notifierRef = React.createRef();

    const cardStyle = {
        background: "white",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px",
        width: isMobile ? "80%" : "30%",
        margin: "auto",
        marginTop: isMobile ? "0px" : "10px"
    };

    useEffect(async () => {
        await refreshData();
    }, [mode]);

    const refreshData = async () => {
        const {
            response: { tags, categories }
        } = await Api.lookups();
        // setTags(tags);
        // setCategories(categories);
        setEntity(mode === MODES.TAGS ? tags : categories)
    };

    const deleteItem = async (id) => {
        let response;
        try {
            if (mode === MODES.TAGS) {
                response = await Api.deleteTag(id);
            } else {
                response = await Api.deleteCategory(id);
            }

            if (response.status === 200) {
                refreshData();
                notifierRef?.current?.showSuccess("נמחק בהצלחה");
            } else if (response.status === 400) {
                if (response.response.reason === "tagInUse") {
                    notifierRef?.current?.showError("התג נמצא בשימוש");
                } else if (response.response.reason === "categoryInUse") {
                    notifierRef?.current?.showError("הקטגוריה נמצאת בשימוש");
                } else {
                    notifierRef?.current?.showError(response.response.reason);
                }
            }
        } catch (e) {
            console.log(`Error deleting entity ${id}`, e);
            notifierRef?.current?.showError("שגיאה במחיקה");
        }
    };

    const addItem = async () => {
        if (!newEntityDescription) {
            notifierRef?.current?.showError("הכנס תיאור");
            return;
        }
        let response;
        try {
            if (mode === MODES.TAGS) {
                response = await Api.addTag(newEntityDescription);
            } else {
                response = await Api.addCategory(newEntityDescription);
            }

            if (response.status === 200) {
                refreshData();
                notifierRef?.current?.showSuccess("נוסף בהצלחה");
            } else {
                notifierRef?.current?.showError("שגיאה בהוספה");
            }
        } catch (e) {
            console.log(`Error adding entity ${newEntityDescription}`, e);
            notifierRef?.current?.showError("שגיאה בהוספה");
        }
    };

    return <div>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
            <Button onClick={() => addItem()} className="button">
                הוסף
            </Button>
            <input
                dir="RTL"
                style={{ marginLeft: "10px" }}
                value={newEntityDescription}
                type="text"
                className="text-input"
                placeholder="תיאור"
                onChange={(element) => setNewEntityDescription(element.target.value)}
            />
        </div>
        <div style={cardStyle}>
            <Table dir="RTL" style={{ width: "90%", margin: "auto" }}>
                <thead>
                    <tr>
                        <th style={{ width: "20px" }}>מזהה</th>
                        <th style={{ width: "100px" }}>תיאור</th>
                        {mode === MODES.CATEGORIES &&
                            <th style={{ width: "20px" }}>חלק מהמאזן?</th>}
                        <th style={{ width: "20px" }}>מחק</th>
                    </tr>
                </thead>
                <tbody>
                    {entity.map(({ id, description, shouldBeIgnored }, index) => {
                        return (
                            <tr style={{ width: "200px" }} key={index}>
                                <td>{id}</td>
                                <td>{description}</td>
                                {mode === MODES.CATEGORIES && <td>{shouldBeIgnored ? 'לא' : 'כן'}</td>}
                                <td>
                                    <div onClick={() => deleteItem(id)} style={{ paddingTop: "10%" }}>
                                        <img src={remove_button} style={{ width: "20px", height: "20px" }} />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            <Notifier ref={notifierRef} />
        </div>
    </div>
}